/* ============================================================
   LOVI — LOT 23
   Thème cible : 198820397383 (LOVI V11, UNPUBLISHED)

   Rôle unique : RÉSERVER la 7e rangée (prix unitaire) sur les trois
   cartes de paliers.

   Mesuré sur le DOM V11 : .lovi2-pk__perbottle n'existe que sur la
   carte 2 ("soit 17,45 € le flacon"). document.querySelectorAll(
   '.lovi2-pk__perbottle').length === 1. Les cartes 1 et 3 n'ont pas
   l'élément du tout, donc aucune règle CSS ne peut réserver sa hauteur.
   Ce script insère un span vide dans les cartes qui en manquent.

   Rien n'est supprimé : on ajoute uniquement.
   Idempotent : marqué par data-lot23-reserved, jamais inséré deux fois.
   ============================================================ */
(function () {
  'use strict';

  var CLS = 'lovi2-pk__perbottle';
  var FLAG = 'data-lot23-reserved';

  function reserve() {
    var packs = document.querySelectorAll('[data-lpdp-pack]');
    if (!packs.length) return false;

    for (var i = 0; i < packs.length; i++) {
      var pack = packs[i];
      if (pack.querySelector('.' + CLS)) continue; // déjà présent (carte 2)

      var span = document.createElement('span');
      span.className = CLS;
      span.setAttribute(FLAG, '1');
      span.setAttribute('aria-hidden', 'true');
      // espace insécable : la rangée occupe sa hauteur sans annoncer de texte
      span.innerHTML = '&nbsp;';
      pack.appendChild(span);
    }
    return true;
  }

  function boot() {
    reserve();

    // La buybox peut re-rendre les paliers au clic (data-variant-id, prix,
    // cadeaux, cadenas). On re-réserve après chaque interaction, sans
    // toucher à .is-selected ni au reste de la logique existante.
    var host = document.querySelector('.lpdp-packs');
    if (host) {
      host.addEventListener('click', function () {
        window.setTimeout(reserve, 60);
      }, true);

      if (window.MutationObserver) {
        var mo = new MutationObserver(function () {
          reserve();
        });
        mo.observe(host, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
